import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Search, RotateCcw } from "lucide-react";
import { CardShell } from "@/shared/ui/CardShell";
import { CardMenu } from "@/shared/ui/CardMenu";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { marketingReportConfig } from "./data";
import { MarketingDonutChart } from "./components/MarketingDonutChart";

export function MarketingReport() {
  const { t } = useTranslation();
  const { donutData } = marketingReportConfig;

  const stats = [
    { id: "search", label: t.crm.searchVolume, value: "+2.9k", icon: Search, bg: "bg-pink-soft", color: "text-pink" },
    { id: "ratio", label: t.crm.returnRatio, value: "1.22", icon: RotateCcw, bg: "bg-yellow-soft", color: "text-yellow" },
  ];

  return (
    <CardShell>
      <div className="flex items-start justify-between">
        <p className="text-sm font-medium text-muted">{t.crm.marketingReport}</p>
        <CardMenu />
      </div>

      <div className="mt-5 space-y-4">
        {stats.map(({ id, label, value, icon: Icon, bg, color }) => (
          <div key={id} className="flex items-center gap-3">
            <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${bg}`}>
              <Icon size={18} className={color} strokeWidth={1.75} />
            </div>
            <div>
              <p className="text-xs text-muted">{label}</p>
              <p className="text-sm font-bold text-foreground">{value}</p>
            </div>
          </div>
        ))}
      </div>

      <MarketingDonutChart data={donutData} />
    </CardShell>
  );
}
